import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const DashboardContent = (): JSX.Element => {
    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
            {/* cards */}
            <Typography component="h2" variant="h6" sx={{ mb:2, mt:2 }}>
                Overview
            </Typography>
        </Box>
    );
}

export default DashboardContent;